<template>
  <v-col :cols="12" :sm="12" :md="12">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <DataTable
      v-show="showSkeletonTable == false"
      :tableTitle="'Pacientes'"
      :newRowmodalButtonText="'Novo Paciente'"
      :tableHeader="headers"
      :tableRows="listaPacientes"
      :isEdit="true"
      :isFinish="false"
      :isDel="true"
      :isPrint="false"
      :totalItens="total"
      v-on:datatable-newrow="modalInserir"
      v-on:datatable-updaterow="modalAtualizar"
      v-on:datatable-deleterow="modalDeletar"
      v-on:datatable-update-page="updatePage"
      v-on:datatable-update-search="updateSearch"
    ></DataTable>

    <SkeletonTable
      v-show="showSkeletonTable == true"
      :showSkeletonTable="showSkeletonTable"
    ></SkeletonTable>

    <Loading :open="loading" />

    <ModalCustomSize
      :modalSize="modalCustomSize.modalSize"
      :isTheModalOpen="modalCustomSize.isOpen"
      :modalButtonText="modalCustomSize.buttonText"
      :modalFormTitle="modalCustomSize.formTitle"
      :modalType="modalCustomSize.modalType"
      :isLoadingRequestDisable="modalCustomSize.isLoadingRequestDisable"
      :isModalButtonVisible="modalCustomSize.isButtonsVisible"
      :isModalButtonDisabled="modalCustomSize.isButtonsDisabled"
      v-on:formmodal-close="modalCustomSize.isOpen = false"
      v-on:formmodal-action="onFormModalAction"
    >



      <v-form id="comeco" v-model="estaValido">
        <v-row>
          <v-col cols="12">
            <AlertasModal
              :tipo="alertaModal.tipo"
              :texto="alertaModal.texto"
            ></AlertasModal>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSize.actualEdit.descricaoNome"
              name="descricaoNome"
              label="Nome completo do Paciente"
              autocomplete="off"
              :rules="[rules.requerido, rules.vazio, rules.limitCharacters]"
              counter="255"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-menu
              ref="menuDataNascimento"
              v-model="menuDataNascimento"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formataDataNascimento"
                  label="Data Nascimento"
                  persistent-hint
                  v-bind="attrs"
                  @blur="date = parseDate(formataDataNascimento)"
                  v-on="on"
                  v-mask="['##/##/####']"
                  autocomplete="off"
                  :rules="rules.data"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                no-title
                @input="menuDataNascimento = false"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.actualEdit.descricaoTelefone"
                name="descricaoTelefone"
                label="Telefone de contato"
                autocomplete="off"
              ></v-text-field>
            </v-col>

            
            <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.actualEdit.descricaoEndereco"
                name="descricaoEndereco"
                label="Endereço"
                autocomplete="off"
              ></v-text-field>
            </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="modalCustomSize.actualEdit.descricaoRG"
              name="descricaoRG"
              label="RG do Paciente"
              v-mask="['####################']"
              autocomplete="off"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="descricaoCpf"
              name="descricaoCpf"
              label="CPF"
              autocomplete="off"
              v-mask="['###.###.###-##']"
              @change="validaCpf()"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-expand-transition>
          <v-row v-if="campoResponsavel">
            <v-col cols="12">
              <v-subheader>Informações do Responsável</v-subheader>
              <v-divider />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="modalCustomSize.actualEdit.nomeResponsavelPaciente"
                name="nomeResponsavelPaciente"
                label="Nome completo do Responsável"
                autocomplete="off"
                counter="255"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="modalCustomSize.actualEdit.cpfResponsavelPaciente"
                name="cpfResponsavelPaciente"
                label="CPF do Responsável"
                autocomplete="off"
                v-mask="['###.###.###-##']"
                @change="verificaCpfRepetidos(modalCustomSize.actualEdit.cpfResponsavelPaciente, descricaoCpf)"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-menu
                ref="menuDataNascimentoResponsavel"
                v-model="menuDataNascimentoResponsavel"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formataDataNascimentoResponsavel"
                    label="Data Nascimento"
                    persistent-hint
                    v-bind="attrs"
                    @blur="dateResponsavel = parseDate(formataDataNascimentoResponsavel)"
                    v-on="on"
                    autocomplete="off"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateResponsavel"
                  no-title
                  @input="menuDataNascimentoResponsavel = false"
                ></v-date-picker>
              </v-menu>
            </v-col>




          </v-row>
        </v-expand-transition>
      </v-form>
      <v-row>
                  <v-col cols="12" v-if="dispensasDoPaciente.length > 0">
                      <v-subheader>Dispensas</v-subheader>
                      <v-divider />

                      <v-list>
                          <v-list-group
                          v-for="(dispensa, i) in dispensasDoPaciente"
                          :key="i"
                          no-action
                          >

                          <template v-slot:activator>
                              <v-list-item-content>
                              <v-list-item-title v-text="'Dispensa da Unidade: '+dispensa.endereco.nomeEndereco+' - '+formatarData(dispensa.dispensaPaciente.dataDispensa)"></v-list-item-title>
                              </v-list-item-content>
                          </template>

                          <v-list-item-content>
                              <v-row cols="12" align="center">
                              <v-col cols="12" class="px-4">
                                  <DataTable
                                  :tableTitle="'Produtos dispensados para o paciente'"
                                  :tableHeader="headersItensDispensados"
                                  :tableRows="dispensa.listaDeItens"
                                  ></DataTable>
                              </v-col>
                              </v-row>
                          </v-list-item-content>


                          </v-list-group>
                      </v-list>
                  </v-col>
              </v-row>
    </ModalCustomSize>
    <DeleteItemModal
      :textModalDelete="modalDelete.textModalDelete"
      :showModalDelete="modalDelete.fecharModal"
      :buttomTextModalDelete="'Excluir'"
      v-on:on-response-modal-delete="resultadoModalDelete"
      v-on:close-modal="modalDelete.fecharModal = false"
    ></DeleteItemModal>

    <AlertaSnackbar :habilitar="alertaSnackbar.mostrar" :texto="alertaSnackbar.texto" :cor="alertaSnackbar.cor" v-on:snack-close="alertaSnackbar.mostrar = false" />
  </v-col>
</template>

<script>
import axios from "../plugins/axios";
import DataTable from "../components/DataTable2";
import store from "@/store/index";
import Loading from "../components/Loading.vue";
import ModalCustomSize from "../components/ModalCustomSize";
import DeleteItemModal from "../components/DeleteItemModal";
import SkeletonTable from "../components/SkeletonTable";
import Alertas from "../components/Alertas.vue";
import AlertasModal from "../components/AlertasModal.vue";
import AlertaSnackbar from "../components/AlertaSnackbar.vue";

export default {
  components: {
    DataTable,
    Loading,
    ModalCustomSize,
    DeleteItemModal,
    SkeletonTable,
    Alertas,
    AlertasModal,
    AlertaSnackbar
  },

  watch: {


    date(val) {
      this.formataDataNascimento = this.formatDate(this.date);
      this.modalCustomSize.actualEdit.dataNascimento = val;
      const validacaoIdade = this.calculateAge
      if(validacaoIdade) {
        this.campoResponsavel = false
        this.modalCustomSize.actualEdit.nomeResponsavelPaciente = null
        this.modalCustomSize.actualEdit.cpfResponsavelPaciente = null
        this.modalCustomSize.actualEdit.dataNascimentoResponsavelPaciente = null
      } else {
        this.campoResponsavel = true
      }
    },

    dateResponsavel(val) {
      this.formataDataNascimentoResponsavel = this.formatDate(this.dateResponsavel);
      this.modalCustomSize.actualEdit.dataNascimentoResponsavelPaciente = val;
    },

    async descricaoCpf() {
      this.modalCustomSize.actualEdit.descricaoCpf = this.descricaoCpf;
    },

    estaValido() {
      this.modalCustomSize.isButtonsDisabled = !this.estaValido
    }
  },

  computed:{
    calculateAge: function() {
      let dataAtual = new Date();
      let dataNascimento = new Date(this.date);
      let diferenca = dataAtual - dataNascimento;
      let age = Math.floor(diferenca/31557600000);
      if(age > 2) {
        return true
      } else {
        return false
      }
    },
  },

  data: () => ({
    //Paginação 
    page: 1,
    search: null,
    total: null,
    //Fim da paginação
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    alertaModal: {
      texto: "",
      tipo: "",
    },

    alertaSnackbar: {
      mostrar: false,
      texto: null,
      cor: "red"
    },

    modalDelete: {
      numeroPaciente: null,
      fecharModal: null,
      textModalDelete: "Você realmente deseja deletar esse paciente?",
      descricaoTela: "Paciente",
    },

    //V-FORM
    estaValido: false,
    campoResponsavel: false,

    //SkeletonTable
    showSkeletonTable: true,
    loading: false,

    //DatePicker
    date: null,
    formataDataNascimento: null,
    menuDataNascimento: false,

    dateResponsavel: null,
    formataDataNascimentoResponsavel: null,
    menuDataNascimentoResponsavel: false,

    // Cabeçalho da DataTable
    headersItensDispensados: [
    {
      text: "ID",
      value: "itemDispensa.numeroItemDispensaPaciente",
    },
    {
      text: "Lote",
      value: "item.lote",
    },
    {
      text: "Nome Produto",
      value: "itemSistema.nomeItemSistema",
    },
    {
      text: "Validade",
      value: "item.validade",
    },
    {
      text: "Qt. Atual",
      value: "itemUnidade.quantidadeEstoque",
    },
    {
      text: "Quantidade Dispensada",
      value: "itemDispensa.quantidadeDispensada",
    }
  ],
    headers: [
      {
        text: "ID",
        value: "numeroPaciente",
      },
      {
        text: "Nome",
        value: "descricaoNome",
      },
      {
        text: "CPF",
        value: "descricaoCpf",
      },
      {
        text: "RG",
        value: "descricaoRG",
      },
      {
        text: "Data Nascimento",
        value: "dataNascimento",
      },
      {
        text: "Responsável do Paciente",
        value: "descricaoNomeResponsavel",
      },
      {
        text: "CPF do Responsável",
        value: "descricaoCpfResponsavel",
      },
      {
        text: "Data Nascimento do Responsável",
        value: "descricaoDataNascimentoResponsavel",
      },
      { text: "Ações", value: "actions", sortable: false },
    ],
      dispensasDoPaciente:[],

    modalCustomSize: {
      modalSize: "1080",
      isOpen: false,
      buttonText: "",
      formTitle: "",
      isEdit: false,
      isButtonsVisible: true,
      isButtonsDisabled: false,
      isLoadingRequestDisable: false,
      actualEdit: {
        numeroEndereco: store.state.numeroEndereco,
        numeroPaciente: null,
        descricaoNome: null,
        descricaoRG: null,
        descricaoCpf: null,
        dataNascimento: null,
        nomeResponsavelPaciente: null,
        cpfResponsavelPaciente: null,
        dataNascimentoResponsavelPaciente: null,
        descricaoEndereco: null,
        descricaoTelefone: null,
        descricaoTela: "Paciente",
      },
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    //RULES
    rules: {
      limitCharacters: v => v && v.length <= 255 || 'Limite de 255 caracteres.',
      requerido: (value) => value != null || "Requer o campo!",
      vazio: v => (v && v.length >= 1) || 'Não pode ser vazio',
      validaCpf: () => true || "CPF já cadastrado!",
      data: [
        (v) => !!v || "Data de Nascimento é obrigatório",
        (v) => (v && v.length >= 10) || "Data contém um formato invalido",
      ],
    },

    //Watch validação
    descricaoCpf: null,

    //Array de objetos para listagem
    listaPacientes: []
  }),

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      try {
        await this.listarPacientes();
      } catch (error) {
        console.log(error);
      }
    },

    /****************************************************************
     *                 FUNÇÕES DE EVENTO
     *****************************************************************/

   async updateSearch(search){
     if(search){
       this.search = search
       this.page = 1
       await this.listarPacientes()
     }else{
       this.page = 1
     }
   },

   async updatePage(pagination){
     this.page = pagination.page
     await this.listarPacientes()
    },

    modalInserir() {
      this.loading = true
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = false;
      this.modalCustomSize.buttonText = "Concluir";
      this.modalCustomSize.formTitle = "Novo Paciente";
      this.modalCustomSize.isButtonsDisabled = !this.estaValido

      this.modalCustomSize.actualEdit.descricaoNome = null;
      this.modalCustomSize.actualEdit.descricaoRG = null;
      this.modalCustomSize.actualEdit.descricaoCpf = null;
      this.modalCustomSize.actualEdit.dataNascimento = null;
      this.modalCustomSize.actualEdit.nomeResponsavelPaciente = null;
      this.modalCustomSize.actualEdit.cpfResponsavelPaciente = null;
      this.modalCustomSize.actualEdit.dataNascimentoResponsavelPaciente = null;
      this.modalCustomSize.actualEdit.descricaoEndereco = null;
      this.modalCustomSize.actualEdit.descricaoTelefone = null;
      this.dispensasDoPaciente = []
  

      this.date = null;
      this.descricaoCpf = null;
      this.dateResponsavel = null;
      this.loading = false
    },
    formatarData(data) {
    if (!data) return null;
    let ano = data.split("-")[0];
    let mes = data.split("-")[1];
    let dia = data.split("-")[2];
    let dia2 = dia.substring(0, 2);

    return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
  },
    async listarDispensasDoPaciente(cpfPaciente){
        try {
        this.dispensasDoPaciente = [];
        const listaDispensas = await axios.put(
          "listarDispensasAntigas",
          { cpf: cpfPaciente },
          this.config
        );

        this.dispensasDoPaciente = listaDispensas.data;
        
       
      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

   async modalAtualizar(item) {
    await this.listarDispensasDoPaciente(item.descricaoCpf)
      this.loading = true
      this.modalCustomSize.isOpen = true;
      this.modalCustomSize.isEdit = true;
      this.modalCustomSize.buttonText = "Concluir";
      this.modalCustomSize.formTitle = "Atualizar Paciente";
      this.modalCustomSize.isButtonsDisabled = !this.estaValido

      this.modalCustomSize.actualEdit.numeroPaciente = item.numeroPaciente;
      this.modalCustomSize.actualEdit.descricaoNome = item.descricaoNome;
      this.modalCustomSize.actualEdit.descricaoCpf = item.descricaoCpf;
      this.modalCustomSize.actualEdit.dataNascimento = this.formatarDataTipoBanco(item.dataNascimento);
      this.modalCustomSize.actualEdit.dataNascimentoFormatado = this.formataDataPadraoBrasileiro(item.dataNascimento);
      this.modalCustomSize.actualEdit.descricaoRG = item.descricaoRG;
      this.modalCustomSize.actualEdit.nomeResponsavelPaciente = item.descricaoNomeResponsavel;
      this.modalCustomSize.actualEdit.cpfResponsavelPaciente = item.descricaoCpfResponsavel;
      this.modalCustomSize.actualEdit.descricaoEndereco = item.descricaoEndereco;
      this.modalCustomSize.actualEdit.descricaoTelefone = item.descricaoTelefone;
      this.modalCustomSize.actualEdit.dataNascimentoResponsavelPaciente = this.formatarDataTipoBanco(item.descricaoDataNascimentoResponsavel);
      this.modalCustomSize.actualEdit.dataNascimentoResponsavelPacienteFormatado = this.formataDataPadraoBrasileiro(item.descricaoDataNascimentoResponsavel);

      this.date = this.parseDate(this.modalCustomSize.actualEdit.dataNascimentoFormatado);
      this.dateResponsavel = this.parseDate(this.modalCustomSize.actualEdit.dataNascimentoResponsavelPacienteFormatado);
      this.descricaoCpf = item.descricaoCpf;




      this.loading = false
    },

    modalDeletar(item) {
      this.loading = true
      this.modalDelete.numeroPaciente = item.numeroPaciente;
      this.modalDelete.fecharModal = true;
      this.loading = false
    },

    async resultadoModalDelete() {
      try {
        await this.delete();
      } catch (error) {
        console.log(error);
      } finally {
        this.modalDelete.fecharModal = false;
      }
    },

    async onFormModalAction() {
      try {
        this.modalCustomSize.isButtonsDisabled = true;
        if (this.modalCustomSize.isEdit) {
          await this.update(this.modalCustomSize.actualEdit);
        } else {
          await this.inserir(this.modalCustomSize.actualEdit);
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.modalCustomSize.isButtonsDisabled = false;
      }
    },

    async validaCpf() {
      try {
        if(this.descricaoCpf !== null && this.descricaoCpf !== '') {
          const cpfValido = this.verificaCpf(this.descricaoCpf)

          if(cpfValido) {
            this.alertaModal.tipo = "";
            this.alertaModal.texto = "";
            this.alertaSnackbar.mostrar = false;

            const validacao = await axios.put("validaCpf", { cpfPaciente: this.descricaoCpf }, this.config);
    
            if(validacao.data) {
              this.rules.validaCpf = false;
              this.alertaModal.tipo = "erro";
              this.alertaModal.texto = "Este CPF já esta cadastrado no Sistema.";
              this.alertaSnackbar.texto = "Este CPF já esta cadastrado no Sistema.";
              this.alertaSnackbar.mostrar = true;
              this.modalCustomSize.isButtonsDisabled = true;
            } else {
              this.rules.validaCpf = true;
              this.alertaModal.tipo = "";
              this.alertaModal.texto = "";
              this.alertaSnackbar.mostrar = false;
            }
          }

        } else {
          this.modalCustomSize.isButtonsDisabled = false;
          this.rules.validaCpf = true;
          this.alertaModal.tipo = "";
          this.alertaModal.texto = "";
        }

      } catch (error) {
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      }
    },

    verificaCpfRepetidos(cpfResponsavel, cpfPaciente) {
      if(cpfPaciente) {
        if(cpfResponsavel == cpfPaciente) {
          this.alertaModal.texto = "O CPF inserido no campo do responsável é o mesmo CPF inserido no campo do paciente, se o CPF inserido for do responsável deixe salvo apenas no campo do responsável.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "O CPF inserido no campo do responsável é o mesmo CPF inserido no campo do paciente, se o CPF inserido for do responsável deixe salvo apenas no campo do responsável.";
          this.alertaSnackbar.mostrar = true;
          this.modalCustomSize.isButtonsDisabled = true;
        } else {
          this.alertaModal.tipo = "";
          this.alertaSnackbar.mostrar = false;
          this.verificaCpf(cpfResponsavel, 2)
        }
      } else {
        this.alertaModal.tipo = "";
        this.alertaSnackbar.mostrar = false;
      }
    },

    verificaCpf(strCPF, tipo) {
      var Soma;
      var Resto;
      Soma = 0;

      const cpfSeparado = strCPF.split(/[.-]+/)
      const cpfFormatado = cpfSeparado.join('')

      if (cpfFormatado == "00000000000" || cpfFormatado == "11111111111" || cpfFormatado == "22222222222" || cpfFormatado == "33333333333" || cpfFormatado == "44444444444" || cpfFormatado == "55555555555" || cpfFormatado == "66666666666" || cpfFormatado == "77777777777" || cpfFormatado == "88888888888" || cpfFormatado == "99999999999") {
        this.rules.validaCpf = false;
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        if(tipo == 1) {
          this.alertaModal.texto = "CPF do paciente é inválido! O CPF não é um CPF real, verifique com o paciente antes de continuar.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "CPF do paciente é inválido! O CPF não é um CPF real, verifique com o paciente antes de continuar.";
          this.alertaSnackbar.mostrar = true;
        } else if(tipo == 2) {
          this.alertaModal.texto = "CPF do responsável é inválido! O CPF não é um CPF real, verifique com o responsável antes de continuar.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "CPF do responsável é inválido! O CPF não é um CPF real, verifique com o responsável antes de continuar.";
          this.alertaSnackbar.mostrar = true;
        }
        return false;  
      }

      for (let i=1; i<=9; i++) Soma = Soma + parseInt(cpfFormatado.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

        if ((Resto == 10) || (Resto == 11))  Resto = 0;
        if (Resto != parseInt(cpfFormatado.substring(9, 10)) ) {
          this.rules.validaCpf = false;
          if(tipo == 1) {
            this.alertaModal.texto = "CPF do paciente é inválido! O CPF não é um CPF real, verifique com o paciente antes de continuar.";
            this.alertaModal.tipo = "erro";
            this.alertaSnackbar.texto = "CPF do paciente é inválido! O CPF não é um CPF real, verifique com o paciente antes de continuar.";
            this.alertaSnackbar.mostrar = true;
          } else if(tipo == 2) {
            this.alertaModal.texto = "CPF do responsável é inválido! O CPF não é um CPF real, verifique com o responsável antes de continuar.";
            this.alertaModal.tipo = "erro";
            this.alertaSnackbar.texto = "CPF do responsável é inválido! O CPF não é um CPF real, verifique com o responsável antes de continuar.";
            this.alertaSnackbar.mostrar = true;
          }
          this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
          return false;
        }

      Soma = 0;
      for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(cpfFormatado.substring(i-1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto != parseInt(cpfFormatado.substring(10, 11) ) ) {
        this.rules.validaCpf = false;
        if(tipo == 1) {
          this.alertaModal.texto = "CPF do paciente é inválido! O CPF não é um CPF real, verifique com o paciente antes de continuar.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "CPF do paciente é inválido! O CPF não é um CPF real, verifique com o paciente antes de continuar.";
          this.alertaSnackbar.mostrar = true;
        } else if(tipo == 2) {
          this.alertaModal.texto = "CPF do responsável é inválido! O CPF não é um CPF real, verifique com o responsável antes de continuar.";
          this.alertaModal.tipo = "erro";
          this.alertaSnackbar.texto = "CPF do responsável é inválido! O CPF não é um CPF real, verifique com o responsável antes de continuar.";
          this.alertaSnackbar.mostrar = true;
        }
        this.modalCustomSize.isButtonsDisabled = !this.isFormValid;
        return false;
      }

      this.rules.validaCpf = true;
      this.alertaModal.texto = "";
      this.alertaModal.tipo = "";
      this.alertaSnackbar.mostrar = false;
      return true;
    },

    //#region Formatação Datas
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formataDataPadraoBrasileiro(data) {
      if (data) {
        var ano = data.split("-")[0];
        var mes = data.split("-")[1];
        var dia = data.split("-")[2];
        var dia2 = dia.substring(0, 2);
        return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
        // Utilizo o .slice(-2) para garantir o formato com 2 digitos.
      } else {
        return null;
      }
    },

    formatarDataTipoBanco(data) {
      if(data) {
        var ano  = data.split("-")[0];
        var mes  = data.split("-")[1];
        var dia  = data.split("-")[2];
        var dia2  = dia.substring(0,2)
        
        return ano + "-" + ("0" + mes).slice(-2) + "-" + ("0" + dia2).slice(-2);
      } else {
        return null;
      }
    },
    //#endregion

    /****************************************************************
     *                  FUNÇÕES DE REQUISIÇÕES
     ************************************************************** */

    async listarPacientes() {
      try {
        let response = await axios.put("listarPacientePagination", {page: this.page, search: this.search} ,this.config);
        this.listaPacientes = response.data;
        this.total = this.listaPacientes[0].total
        this.showSkeletonTable = false;
      } catch (error) {
        console.log(error);
      }
    },

    async inserir(dadosPaciente) {
      try {
        this.alertaSnackbar.mostrar = false;
        this.modalCustomSize.isLoadingRequestDisable = true;
        await axios.post("inserirPaciente", dadosPaciente, this.config);

        this.alerta.texto = "Paciente adicionado com sucesso!";
        this.alerta.tipo = "sucesso";
        this.modalCustomSize.isOpen = false;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.initialize();
      }
    },

    async update(dadosPaciente) {
      try {
        this.alertaSnackbar.mostrar = false;
        this.modalCustomSize.isLoadingRequestDisable = true;
        await axios.put("atualizarPaciente", dadosPaciente, this.config);

        this.alerta.texto = "Paciente atualizado com sucesso!";
        this.alerta.tipo = "sucesso";
        this.modalCustomSize.isOpen = false;
      } catch (error) {
        console.log(error);
        this.alertaModal.texto = error.response.data.message;
        this.alertaModal.tipo = "erro";
        this.alertaSnackbar.texto = error.response.data.message;
        this.alertaSnackbar.mostrar = true;
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.initialize();
      }
    },

    async delete() {
      try {
        this.modalCustomSize.isLoadingRequestDisable = true;
        await axios.delete("deletarPaciente", {
          data: this.modalDelete,
          headers: this.config.headers,
        });

        this.alerta.texto = "Paciente removido com sucesso!";
        this.alerta.tipo = "sucesso";
      } catch (error) {
        console.log(error);
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.modalCustomSize.isLoadingRequestDisable = false;
        this.initialize();
      }
    },
  },
};
</script>
